import type { Locale } from 'date-fns'
import { es } from 'date-fns/locale/es'
import { fr } from 'date-fns/locale/fr'
import { de } from 'date-fns/locale/de'
import { zhCN } from 'date-fns/locale/zh-CN'

const dateFnsLocales: Record<string, Locale> = { es, fr, de, zh: zhCN }

export function getDateLocale(lang: string): Locale | undefined {
  return dateFnsLocales[lang]
}
